export const getEventTextFromCount = (count: number | undefined) => {
  if (typeof count === 'undefined') {
    return '';
  }

  if (count === 1) {
    return 'событие';
  }
  if (count > 1 && count < 5) {
    return 'события';
  }
  return 'событий';
};
